import {ModuleWithProviders, NgModule} from '@angular/core';
import {HttpClientModule} from "@angular/common/http";
import {DxObjectMapper} from "./services/dx-object-mapper.service";
import {DxConfigService} from "./services/dx-config.service";
import {DxHttpDispatcher} from "./services/dx-http-dispatcher.service";
import {LoggerModule, NgxLoggerLevel} from "ngx-logger";
import {DxErrorHandler} from "./services/dx-error-handler.service";
import {DxGlobalWaiterService} from "./services/dx-global-waiter.service";
import {DxGlobalWaiter} from "./ui/components/waiter/dx-global-waiter.component";
import {DxLogger} from "./services/dx-logger.service";
import {DX_CORE_CONFIG, DxCoreConfig} from "./config/dx-core-config";
import {DxErrorService} from "./services/dx-error.service";
import {DxEncryptionService} from "./services/dx-encryption.service";
import {DxBasicEncryptionStrategy} from "./services/strategy/dx-basic-encryption-strategy";
import {DxKeycloakEncryptionStrategy} from "./services/strategy/dx-keycloak-encryption-strategy";
import {CommonModule} from "@angular/common";
import {DxSafeHtmlPipe} from "./pipes/dx-safe-html.pipe";
import {DxSafeUrlPipe} from "./pipes/dx-safe-url.pipe";



/**
 * Shared-модуль, предоставляющий "ядровую" функциональность типового CRUD вэб-приложения:
 *
 * 1. Механизм загрузки настроек приложения из `environment`-объектов или асинхронно с сервера \ `json`-файлов
 * 2. Обертка над `HttpClient` для гибкого перенаправления приложения на разные схемы
 * 3. Глобальная индикация асинхронной загрузки данных
 * 4. Механизим маппинга ответов сервера в `ts`-объекты по средствам аннотаций
 * 5. Глобальная обработка ошибок и аварийная страница
 * 6. Логирование с возможностью перенаправления данных на сервер (логгироване действий на клиенте в серверной части)
 * 7. Перехватчик для логгирования http-запросов
 * 8. Сервис и набор стратегий для шифрования данных
 *
 *  @publicApi
 */
@NgModule({
  declarations: [
    DxGlobalWaiter,
    DxSafeHtmlPipe,
    DxSafeUrlPipe
  ],
  exports: [
    DxGlobalWaiter,
    DxSafeHtmlPipe,
    DxSafeUrlPipe,
  ],
  imports: [
   CommonModule,
   HttpClientModule,
   LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG }),
   /*NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '4px',
      primaryColour: '#960530',
      secondaryColour: '#006ddd',
      tertiaryColour: '#00CC00'
   }),*/
  ],
  providers: [
    DxConfigService,
    DxLogger,
    DxErrorHandler,
    DxErrorService,
    DxObjectMapper,
    DxHttpDispatcher,
    DxEncryptionService,
    DxBasicEncryptionStrategy,
    DxKeycloakEncryptionStrategy,
    DxGlobalWaiterService
  ],
  bootstrap: []
})
export class DxCoreModule {
  // forRoot() / forChild() регулируют только состав провайдеров модуля
  // для eager/lazy загрузки
  /**
   *  Вохвращает конфигурацию `DxCoreModule` для импортирования в корневом модуле приложения.
   *  Lazy-load импортирование `DxCoreModule` не поддерживается ввиду его бессмыленности.
   *
   *  @param {DxCoreConfig} config - объект с конфигурацией ядра.
   *  @return сконфигурированный модуль с провайдерами.
   */
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DxCoreModule,
      providers: [
        DxConfigService,
        DxLogger,
        DxErrorHandler,
        DxErrorService,
        DxObjectMapper,
        DxHttpDispatcher,
        DxEncryptionService,
        DxBasicEncryptionStrategy,
        DxKeycloakEncryptionStrategy,
        DxGlobalWaiterService
      ]
    };
  }
}
